<template lang='pug'>
  .container-fluid.p-0.push-wrapper
    .container
      .row
        .col
          .row
            .col-12.my-header.font-weight-bold
              | Настройки системы

    .container
        .white_block
            .row
                .col-sm-6.shopSettings
                    .inputModule
                        input-module(type="select" title="Приветственная группа" v-model="shopSettings.default_group" :values="groups" valueKey="client_group_id" valueName="client_group_name" about="В какую группу попадает новый гость при регистрации?")
                    //- .inputModule
                    //-     input-module(type="checkbox" title="Пуш «‎Спасибо за визит»" disabled="true" v-model="shopSettings.thanks_pushes" label="Включить" about="Когда чек закроется, гостю придёт пуш с благодарностью за визит.")
                    .inputModule
                        input-module(type="checkbox" title="Геопуши на iOS" disabled="true" v-model="shopSettings.geopushIOS" label="Включить")
                    .inputModule
                        input-module(type="checkbox" title="Геопуши на Android" disabled="true" v-model="shopSettings.geopushAndroid" label="Включить")
                    button.styled(v-on:click="saveSettingns()" :disabled="groups.length==0") Сохранить


</template>
<script>
import { Tooltip } from "element-ui";
import moment from "moment";
import apiDriver from '../../apiDriver';

export default {
  components: {
    [Tooltip.name]: Tooltip
  },

  data() {
    return {
      shopSettings: {
        default_group: '',
        thanks_pushes: 0,
        geopushIOS: 0,
        geopushAndroid: 0
      },
      groups: []
    };
  },

  computed: {},

  mounted() {
    this.loadShopSettings();
    this.loadUserGroups();
  },

  methods: {
    async loadUserGroups(){
      let x = (await apiDriver.services.api.get("cards", "settings/getAllPosGroups")).data;
      // console.log(x.groups)
      this.groups = x.groups;
    },
    async loadShopSettings(){
      let x = (await apiDriver.services.api.get("cards", "settings/shopConfig")).data;
      // console.log('loadShopSettings:',x.settings);
      this.shopSettings = x.settings;
    },
    async saveSettingns(){
      this.$toast.success('Настройки успешно сохранены!')
      // this.$notify({type: 'success', title: 'Уведомление', text: 'Настройки успешно сохранены!'});
      let x = (await apiDriver.services.api.post("cards", "settings/shopConfig", this.shopSettings)).data;
      // console.log("saveSttings:", x);
      // this.se = x.groups;
    },




  }
};
</script>
<style scoped lang="stylus">
div
  cursor: default
.my-header
  font-size: 26pt;
.header-pre-push
  font-size: 1.5rem
.header-push
  font-size: 1.5rem
  color: black

button.styled {
  margin-bottom: 5px;
  border: 1px solid #6c68cb;
  padding: 10px 15px;
  border-radius: 4px;
  color: #464384;
  cursor: pointer;
  background: white;

  &:hover {
    background: #6c68cb;
    color: white;
  }

  &[disabled] {
    border-color: #ddd;
    color: #ddd;
    cursor: default;
    background: white;
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.design{
  background: white;
}

.inputModule{
  margin-bottom 10px;
}


</style>
